import styled from 'styled-components'
import { Paper } from '@material-ui/core'
import {
  colors,
  theme,
  StyledH2,
  StyledH4,
  StyledH5,
  StyledParagraph,
  StyledH3
} from '../../../theme/Global'

export const CustomPaper = styled(Paper)`
  padding: 0px 40px;
`

export const CustomTitle = styled(StyledH2)`
  margin-top: 10px;
  margin-bottom: 32px;
  text-align: left;
`

export const WageAmount = styled(StyledH2)`
  font-size: 30px;
  text-align: left;
  &:first-letter {
    font-size: 1.3rem;
    vertical-align: super;
    margin-right: 0.125rem;
  }
`
export const JurisdictionType = styled(StyledH3)`
  text-align: left;
  text-transform: capitalize;
  padding-top: 0;
  font-size: 15px;
  color: ${theme.colors.text};
  opacity: 1;
`

export const WageAmountLabel = styled(StyledH4)`
  color: ${theme.colors.text};
  text-align: left;
  padding-bottom: 0;
`

export const CustomH5 = styled(StyledH5)`
  text-align: left;
`
export const WageDetailList = styled.ul`
  padding-left: 12px;
`

export const TopicHeader = styled(StyledH4)`  
  margin: 0;
  padding: 0;
  text-align: left;
`

export const Subheading = styled(StyledH5)`
  margin: 0.6rem 0;
  padding: 0;
  text-align: left;
`

export const MarkdownWrap = styled(StyledParagraph)`
`

export const LawCitation = styled.cite`
  text-align: right;
  width: 100%;
  display: block;
  color: ${theme.colors.text};
  font-size: 1rem;
  padding-top: 0.5rem;
  font-style: inherit;
`

export const StickyTopicNav = styled.ul`
  position: -webkit-sticky;
  position: sticky;
  top: 5px;
  padding: 0;
  > li {
    list-style: none;
    padding: 8px;
    font-size: 14px;
  }
`

export const TopicNav = styled.div`
  align-items: center;
  box-sizing: unset;
  cursor: pointer;
  display: flex;  
  margin-left: 4px;
  padding: 0 0 0 15px;

  &:focus {
    outline: unset;
  }

  &:focus:before {
      padding-left: 10px;
      height: inherit;
      left: 0px;
      
      position: absolute;
      content: " ";
      width: 1rem;
      z-index: 1000;
  }

  &.selected {
    border-left: 4px solid ${colors.govDocsBlue};
    color: ${theme.colors.darkBlueText};
    font-weight: 600;
    margin-left: 0px;
  }
`
